import { map, isPlainObject } from 'lodash';

import { OfferBase } from './bases/offer-base';
import { toApi as toApiBase } from './bases/offer-base';
import { Segment } from './segment';
import { Strategy } from './strategy';

class Translation {
  name: any = {};
  description: any = {};
  legal_terms: any = {};
  application_url: any = {};
}

export class Offer extends OfferBase {
  animation_delay_days = 0;
  application_url: string;
  cashback_budget = null;
  cashback_rate = 5;
  commission_groups: any = [];
  commission_percent = 10;
  commission_rate = 30;
  discount_rate: number = null;
  completion: any = null;
  custom_date = false;
  funded_by: any;
  highlight_level = 'NORMAL';
  is_main_source_transaction: boolean = false;
  max_amount = null;
  max_cashbacks_per_consumer = null;
  max_fixed_reward_amount: any;
  max_reward_rate: any;
  min_amount = null;
  objective: any;
  segments: Segment[] = [];
  strategy: Strategy;
  total_amount = 0;
  translation = new Translation();
  type = 'CASHBACK';

  constructor(payload: Object = {}) {
    super();

    Object.assign(this, payload);

    if (this.cashback_budget) {
      this.completion = (this.total_amount / this.cashback_budget) * 100;
    }

    this.trimTimezoneFromDates();
  }
}

export function toApi(data) {
  data = toApiBase(data);

  if (isPlainObject(data.segments)) {
    data.segments = map(data.segments, 'id');
  }

  if (isPlainObject(data.picture)) {
    data.picture = map(data.picture, 'id');
    data.picture_id = map(data.picture, 'id');
  } else {
    data.picture_id = data.picture
  }

  if (!data.custom_date) {
    delete data.start_date;
    delete data.end_date;
  }

  return data;
}

export function fromApi(data) {
  return data;
}
